import { defineComponent, onBeforeUpdate, onMounted, onUpdated, ref, } from 'vue';
import CatalogItem from '@/components/CatalogItem.vue';
import FilterList from '@/components/FilterList.vue';
import Dropdown from '@/components/Dropdown.vue';
import CircularSpinner from '@/components/CircularSpinner.vue';
import PriceRangeSlider from '@/components/PriceRangeSlider.vue';
import PermalinkList from '@/components/PermalinkList.vue';
import { useCatalog } from '@/catalog';
import $ from 'jquery';
export default defineComponent({
    name: 'Catalog',
    props: {
        config: {
            type: Object,
            required: true,
        },
    },
    components: {
        CircularSpinner,
        CatalogItem,
        FilterList,
        PermalinkList,
        Dropdown,
        PriceRangeSlider,
    },
    setup(props) {
        const { 
        // refs
        products, count, taxRefs, priceRange, selectedPriceRange, order, page, loadingProducts, loadingMoreProducts, 
        // computed
        numberOfPages, previousPage, 
        // methods
        readQueryString, setQueryString, getProductQuery, getCatalogQuery, loadProducts, loadMoreProducts, loadLessProducts, loadProductCount, loadPriceRange, loadAllTaxonomies, addToCartHandle, viewDetailsHandle, addToWishlistHandle, 
        // data
        taxApplier, } = useCatalog(props.config);
        const loadingCatalog = ref(true);
        const sidebar = ref(null);
        const sidebarMoved = ref(false);
        const sidebarOpen = ref(false);
        const ddSet = ref(new Set());
        const initCatalog = async () => {
            const productQuery = getProductQuery();
            const catalogQuery = getCatalogQuery(productQuery);
            loadingCatalog.value = true;
            await Promise.all([
                loadProducts(catalogQuery),
                loadProductCount(productQuery),
                loadAllTaxonomies(productQuery),
                loadPriceRange(catalogQuery),
            ]);
            loadingCatalog.value = false;
        };
        const resetCatalogScroll = () => {
            const catalog = document.querySelector('.main__grid');
            const html = document.querySelector('html');
            if (html === null || catalog === null) {
                return;
            }
            html.scrollTop = catalog.offsetTop;
        };
        const addDdRef = (el) => {
            ddSet.value.add(el);
        };
        const onDdToggle = (e, toggle) => {
            const $dd = $(e.target)
                .parent('.dropdown')
                .find('.dropdown__content');
            const previousState = $dd.css('display');
            for (const el of ddSet.value.values()) {
                $(el.$el).find('.dropdown__content').css('display', 'none');
            }
            if (toggle !== undefined) {
                $dd.css('display', toggle ? 'block' : 'none');
            }
            else {
                $dd.css('display', previousState === 'block' ? 'none' : 'block');
            }
        };
        const reloadOnLoadMore = async () => {
            const productQuery = getProductQuery();
            const catalogQuery = getCatalogQuery(productQuery);
            await loadMoreProducts(catalogQuery);
            setQueryString();
        };
        const reloadOnLoadLess = async () => {
            const productQuery = getProductQuery();
            const catalogQuery = getCatalogQuery(productQuery);
            await loadLessProducts(catalogQuery);
        };
        const reloadOnSelectTerm = async () => {
            page.value = 1;
            selectedPriceRange.value = null;
            const productQuery = getProductQuery();
            const catalogQuery = getCatalogQuery(productQuery);
            await Promise.all([
                loadProducts(catalogQuery),
                loadProductCount(productQuery),
                loadAllTaxonomies(productQuery),
                loadPriceRange(catalogQuery),
            ]);
            setQueryString();
        };
        const reloadOnSelectPriceRange = async () => {
            page.value = 1;
            const productQuery = getProductQuery();
            const catalogQuery = getCatalogQuery(productQuery);
            await Promise.all([
                loadProducts(catalogQuery),
                loadProductCount(productQuery),
                loadAllTaxonomies(productQuery),
            ]);
            setQueryString();
        };
        const reloadOnChangeOrder = async () => {
            page.value = 1;
            const productQuery = getProductQuery();
            const catalogQuery = getCatalogQuery(productQuery);
            await loadProducts(catalogQuery);
            setQueryString();
        };
        const onLoadMoreClick = () => {
            page.value++;
            reloadOnLoadMore();
        };
        const onLoadLessClick = () => {
            reloadOnLoadLess();
        };
        const onFilterListToggle = (tax, term, checked) => {
            const taxRef = taxRefs.get(tax);
            if (taxRef === undefined) {
                console.warn(`Taxonomy \`${tax}\` does not exists`);
                return;
            }
            if (checked) {
                taxRef.selectedTerms.add(term.id);
            }
            else {
                taxRef.selectedTerms.delete(term.id);
                // uncheck recursively its own children
                const uncheckChildren = (term) => {
                    for (const c of term.children) {
                        taxRef.selectedTerms.delete(c.id);
                        if (c.children.length > 0) {
                            uncheckChildren(c);
                        }
                    }
                };
                uncheckChildren(term);
            }
        };
        const onFilterListToggleAndReload = async (tax, term, checked) => {
            onFilterListToggle(tax, term, checked);
            resetCatalogScroll();
            reloadOnSelectTerm();
        };
        const onPriceRangeSliderChange = (values) => {
            selectedPriceRange.value = { min: values[0], max: values[1] };
        };
        const onPriceRangeSliderChangeAndReload = async (values) => {
            onPriceRangeSliderChange(values);
            resetCatalogScroll();
            reloadOnSelectPriceRange();
        };
        const onOrderSelectChange = async (e) => {
            const select = e.target;
            order.value = select.value;
            reloadOnChangeOrder();
        };
        const onDdApplyPriceRange = (e) => {
            onDdToggle(e);
            sidebarOpen.value = false;
            if (selectedPriceRange.value === null)
                return;
            reloadOnSelectPriceRange();
        };
        const onDdApplyFilters = (e) => {
            onDdToggle(e);
            sidebarOpen.value = false;
            reloadOnSelectTerm();
        };
        onBeforeUpdate(() => {
            ddSet.value = new Set();
        });
        onMounted(() => {
            readQueryString();
            initCatalog();
        });
        onUpdated(() => {
            if (sidebarMoved.value) {
                return;
            }
            const tp = props.config.teleportSidebar;
            if (tp === undefined) {
                return;
            }
            const destination = document.querySelector(tp);
            if (destination === null) {
                console.warn(`Teleport destination element ${tp} does not exists. Skipping`);
                return;
            }
            if (sidebar.value !== null) {
                destination.appendChild(sidebar.value);
                sidebarMoved.value = true;
            }
        });
        window.onpopstate = () => {
            readQueryString();
            initCatalog();
        };
        return {
            // catalog refs
            products,
            count,
            order,
            priceRange,
            selectedPriceRange,
            taxRefs,
            loadingCatalog,
            loadingProducts,
            loadingMoreProducts,
            page,
            // catalog computed
            numberOfPages,
            previousPage,
            // refs
            sidebar,
            sidebarOpen,
            // methods
            addDdRef,
            onDdToggle,
            onDdApplyPriceRange,
            onDdApplyFilters,
            onFilterListToggle,
            onFilterListToggleAndReload,
            onOrderSelectChange,
            onPriceRangeSliderChange,
            onPriceRangeSliderChangeAndReload,
            onLoadMoreClick,
            onLoadLessClick,
            addToCartHandle,
            viewDetailsHandle,
            addToWishlistHandle,
            // data
            taxApplier,
        };
    },
});
